import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-data-list',
  templateUrl: './data-list.component.html',
  styleUrls: ['./data-list.component.scss'],
})
export class DataListComponent {
  itemList: any[] = [];
  itemListCopy: any[] = [];
  selectedItem: any;
  inputSelection: string;

  constructor(
    private readonly dialogConfig: DynamicDialogConfig,
    private readonly dynamicDialogRef: DynamicDialogRef
  ) {
    this.itemList = this.itemListCopy = this.dialogConfig.data.itemList;
  }

  onClickImport() {
    this.dynamicDialogRef.close(this.selectedItem);
  }

  onCancel() {
    this.dynamicDialogRef.close();
  }

  onFilter(): void {
    if (this.inputSelection) {
      this.inputSelection = this.inputSelection?.toLowerCase();
      this.itemList =
        this.itemListCopy?.filter((file) =>
          file?.name?.toLowerCase().includes(this.inputSelection)
        ) || [];
    }
  }

  resetFilter(): void {
    this.itemList = this.itemListCopy || [];
    this.selectedItem = null;
    this.inputSelection = '';
  }
}
